import variables from '../variables';
/* eslint-disable */

const MuiPopover = {
  paper: {
    '& .MuiMenuItem-root': {
      '&.lightmode': {
        backgroundColor: variables.colors.white,
        color: variables.colors.midBlue,
        '&:hover': {
          backgroundColor: variables.colors.backgroundMuted,
          color: variables.colors.white,
        },
      },
    },
  },
};

export default MuiPopover;
